import React from 'react';
import BaseRouter from './BaseRouter';

function App() {
  return (
      <BaseRouter />
  );
}

export default App;
